export { default } from "./Hero.jsx";
